'use client';

import dynamic from 'next/dynamic';

const AnimationDotsMeshPure = dynamic(() => import('./AnimationDotsMeshPure'), {
	ssr: false,
});

function AnimationDotsMesh() {
	return <AnimationDotsMeshPure />;
}

export default AnimationDotsMesh;
